<template>
  <div class="InputThree" :class="isactive?'InputThree_active':''">
    <span class="label_name" :class="isMust?'isMust':''">{{name}}</span>
    <el-input
      v-model="value1"
      size="mini"
      :placeholder="placeholder"
      class="input_sty"
      @focus="doFocus"
      @blur="doBlur"
      :disabled="isdisable"
      @input="regrexp(value)"
    ></el-input>
  </div>
</template>
<script>
import tool from "@/utils/tool.js";

export default {
  name: "InputThree",
  data() {
    return {
      isactive: false, //是否聚焦状态
      value1: this.value //绑定数据值
    };
  },
  methods: {
    // 正则验证input
    regrexp(val) {
      switch (this.reg) {
        case "text":
          break;
        case "float":
          this.value1 = this.value1.replace(
            /^\D*(\d*(?:\.\d{0,6})?).*$/g,
            "$1"
          );
          break;
        case "integer":
          this.value1 = this.value1.replace(/[^\d]/g, "");
          break;
        case "phone":
          // this.value1=this.value1.trim().match(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/);
          break;
        case "idcard":
          break;
        default:
          break;
      }
    },
    // 聚焦事件
    doFocus() {
      event.currentTarget.select();
      this.$emit("clickFocus");
      this.isactive = true;
    },
    // 失焦事件
    doBlur() {
      this.$emit("Blur");
      this.isactive = false;
    }
  },
  watch: {
    value() {
      this.value1 = this.value;
    },
    value1() {
      this.$emit("dateChange", this.value1, this.fieldData);
    }
  },
  props: {
    placeholder: String,
    value: [String, Number, Function],
    name: {
      type: String,
      default: "备注"
    },
    // 是否必填
    isMust: {
      type: Boolean,
      default: true
    },
    // 是否可输入
    isdisable: {
      type: Boolean,
      default: false
    },
    // 是否可输入
    reg: {
      type: String,
      default: "text"
    },
    // 传入的外部字段，将用于传出识别
    fieldData: { type: String }
  }
};
</script>

<style lang="less">
.InputThree {
  width: 100%;
  height: 30px;
  display: -webkit-box !important;
  display: box !important;
  position: relative;
  -webkit-box-align: center;
  box-align: center;
  color: #666;
  border: 1px solid #d6e2ed;
  border-radius: 5px;
  padding: 0 5px;
  box-sizing: border-box;
  .label_name {
    height: 100%;
    line-height: 30px;
    font-size: 12px;
    color: inherit;
    font-weight: bold;
  }
  .isMust::after {
    content: "*";
    color: red;
  }
  .input_sty {
    position: relative;
    -webkit-box-flex: 1;
    box-flex: 1;
    display: block;
    height: 100%;
  }
  .el-input__inner,
  .el-input__inner:hover {
    border-color: #fff;
    height: 27px;
    outline: none;
    background: transparent;
    border: none;
  }
}
.el-input.is-disabled .el-input__inner {
  background-color: #fff;
  border-color: #fff;
  color: #333;
}
.InputThree:hover {
  border-color: #2594ff;
  color: #2594ff;
}
.InputThree_active {
  border-color: #2594ff !important;
  color: #2594ff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Input/InputThree/InputThree.vue